module.exports = __webpack_public_path__ + "img/qr-qw.b968e7d8.png";